<template>
  <kst-modal
    class="kst-invoice-price-search"
    :width="950"
    :active="active"
    :title="title"
    @cancel="handleModal_Cancel"
    @submit="handleModal_Submit"
  >
    <kst-section search-mode class="pb-0">
      <Search
        :searchData="searchData"
        @submit="handleSearch_Submit"
        @reset="handleSearch_Reset"
      />
    </kst-section>

    <kst-section search-result-mode select-one-help>
      <List
        :failureList="failureList"
        :isListLoading="isListLoading"
        :items="items"
        :sellPrice="sellPrice"
        :userData="userData"
      />
    </kst-section>
  </kst-modal>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterModel from "@/router/RouterModel.js";
import SnackbarMixin from "@/mixins/SnackbarMixin.js";
import Model from "../InvoiceModel.js";
import Services from "../InvoiceServices.js";

import Search from "./InvoicePriceSearch_Search";
import List from "./InvoicePriceSearch_List";

export default {
  mixins: [AxiosMixin, SnackbarMixin],
  components: {
    Search,
    List
  },
  data: () => ({
    userData: {},
    searchData: {},
    items: [],
    active: false,
    clientId: null,
    clientName: "",
    dispatchId: null,
    invoiceId: null,
    sellPrice: 0,
    isListLoading: false,
    // support debounce
    loadCounter: 0,
    // error
    failureList: null
  }),
  computed: {
    title() {
      return RouterModel.getNavSubTitle(Model.Module, Model.ModuleType.Search);
    }
  },
  methods: {
    init() {
      this.userData = {
        selected: null
      };

      this.initSearch();
    },
    initSearch() {
      this.searchData = {
        Search: "",
        Client: "",
        Date: this.$kst.In.getThreeMonthDay(),
      };
    },

    show(sellPrice, clientId, clientName, dispatchId, invoiceId) {
      this.init();
      this.sellPrice = sellPrice;
      this.clientId = clientId;
      this.clientName = clientName;
      this.searchData.Client = clientName;
      this.dispatchId = dispatchId;
      this.invoiceId = invoiceId;
      this.active = true;
      this.loadList(this.loadCounter, this.searchData);

    },
    hide() {
      this.active = false;
    },

    loadList(counter, searchData) {
      this.failureList = null;
      this.isListLoading = true;
      this.items = [];

      let options = {
        item: this.dispatchId
      };

      if (this.invoiceId) {
        options.excludeid = this.invoiceId;
      }

      if (searchData) {
        options.name = this.$kst.Out.getString(searchData.Search);
        options.client = this.$kst.Out.getString(searchData.Client);
        options.startInvoice = this.$kst.Out.getDate(searchData.Date[0]);
        options.endInvoice = this.$kst.Out.getDate(searchData.Date[1]);
      }

      const config = Services.getInvoicePriceList(options);
      this.runAxios(config, counter, this.loadList_Success, this.loadList_Error);
    },
    loadList_End() {
      this.isListLoading = false;
    },
    loadList_Success(data, counter) {
      // handle repeated execution on slow network to show last request
      if (counter !== this.loadCounter) {
        return;
      }

      this.items = data;
      this.loadList_End();
    },
    loadList_Error(message) {
      this.failureList = message;
      this.loadList_End();
    },

    handleModal_Cancel() {
      this.active = false;
      this.$emit(this.$kst.Enum.Event.Cancel);
    },
    handleModal_Submit() {
      if (this.userData.selected === null) {
        this.notifyError_SelectOne();
        return;
      }

      this.active = false;
      this.$emit(this.$kst.Enum.Event.Submit, this.userData.selected);
    },

    handleSearch_Submit() {
      this.loadCounter++;
      this.loadList(this.loadCounter, this.searchData);
    },
    handleSearch_Reset() {
      this.initSearch();
      this.loadCounter++;
      this.loadList(this.loadCounter, this.searchData);
    }
  }
}
</script>